import { createContext, useContext } from "react";

import { MeetingFormHelper } from "./MeetingFormHelper.ts";

export const MeetingFormContext = createContext<MeetingFormHelper>(
  {} as MeetingFormHelper
);

export const useMeetingFormContext = () => useContext(MeetingFormContext);
